export const DONATION_MODULE_SETTINGS_PATH = "/module/donations";
export const DONATION_MODULE_SETTINGS_ROUTE_NAME = "DonationModuleSettings";
/** Tab order on screen; the first one is the landing tab and the only one left usable while the module is off. */
export const DONATION_MODULE_SETTINGS_TABS = [
    "activation",
    "identity",
    "numbering",
    "trigger",
    "autoEmission",
    "documentTemplates",
    "emailTemplates",
];
export const DONATION_MODULE_SETTINGS_DEFAULT_TAB = "activation";
export function isDonationModuleSettingsTab(value) {
    return typeof value === "string" && DONATION_MODULE_SETTINGS_TABS.includes(value);
}
